import React from 'react';
import { _defineHelpUrlandToolTip } from '../../helpers/index.js'
const LogicOperation = function () {
    const name = "logic_operation";
    LogicOperation.blockName = name;

    _defineHelpUrlandToolTip(name, Blockly.BASE_HELP_URL + "#logic", "Combines two conditions using AND/OR");

    return (
        <block type={name}></block>
    )
};

export default LogicOperation;